module.exports = __webpack_public_path__ + "img/19_40.d94b6f04.png";